import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";

export interface IRemoveModalProps {
  open: boolean;
  handleClose: () => void;
  handleRemove: () => void;
  text: string;
}

export function RemoveModal(props: IRemoveModalProps) {
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{props.text}</DialogTitle>
      <DialogActions>
        <Button color="error" onClick={props.handleRemove} autoFocus>
          Hapus
        </Button>
        <Button onClick={props.handleClose} autoFocus>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
